import {
  OnInit, OnChanges, Directive, Input, Output, EventEmitter, ElementRef, ViewContainerRef, ReflectiveInjector, ComponentFactoryResolver
} from '@angular/core';

import { IconPickerComponent } from './icon-picker.component';


export class IconPickerDirective implements OnInit, OnChanges {
   iconPicker: string;
   ipPlaceHolder = 'Search icon...';
   ipPosition = 'right';
   ipFallbackIcon = 'fa fa-user-plus';
   ipHeight = 'auto';
   ipMaxHeight = '200px';
   ipWidth = '230px';
   ipIconPack = 'all';

   iconPickerSelect = new EventEmitter<string>(true);

  private dialog: any;
  private created: boolean;
  private ignoreChanges = false;

  constructor(
    private vcRef: ViewContainerRef,
    private el: ElementRef,
    private cfr: ComponentFactoryResolver) {
    this.created = false;
  }

  ngOnChanges(changes: any): void {
    if (changes.iconPicker) {
      this.ignoreChanges = false;
    }
  }

  ngOnInit() {
    this.iconPicker = this.iconPicker || this.ipFallbackIcon || 'fa fa-user-plus';
    this.iconPickerSelect.emit(this.iconPicker);
  }

  onClick() {
    this.openDialog();
  }

  openDialog() {
    if (!this.created) {
      this.created = true;
      let vcRef = this.vcRef;
      const compFactory = this.cfr.resolveComponentFactory(IconPickerComponent);
      const injector = ReflectiveInjector.fromResolvedProviders([], vcRef.parentInjector);
      const cmpRef = vcRef.createComponent(compFactory, 0, injector, []);
      cmpRef.instance.setDialog(this, this.el, this.iconPicker, this.ipPosition, this.ipHeight, this.ipMaxHeight,
        this.ipWidth, this.ipPlaceHolder, this.ipFallbackIcon, this.ipIconPack);
      this.dialog = cmpRef.instance;

      if (this.vcRef !== vcRef) {
        cmpRef.changeDetectorRef.detectChanges();
      }
    } else if (this.dialog) {
      this.dialog.openDialog(this.iconPicker);
    }
  }

  iconSelected(icon: string) {
    this.iconPickerSelect.emit(icon);
  }

static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[iconPicker]',
  host    : {
    '(click)': 'onClick()'
  }
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ViewContainerRef, },
{type: ElementRef, },
{type: ComponentFactoryResolver, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'iconPicker': [{ type: Input, args: ['iconPicker', ] },],
'ipPlaceHolder': [{ type: Input, args: ['ipPlaceHolder', ] },],
'ipPosition': [{ type: Input, args: ['ipPosition', ] },],
'ipFallbackIcon': [{ type: Input, args: ['ipFallbackIcon', ] },],
'ipHeight': [{ type: Input, args: ['ipHeight', ] },],
'ipMaxHeight': [{ type: Input, args: ['ipMaxHeight', ] },],
'ipWidth': [{ type: Input, args: ['ipWidth', ] },],
'ipIconPack': [{ type: Input, args: ['ipIconPack', ] },],
'iconPickerSelect': [{ type: Output, args: ['iconPickerSelect', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
